// next-app/src/lib/api.ts
// Environment-based API URL configuration

const ENV = process.env.NEXT_PUBLIC_ENV || 'development';

function getApiUrl(): string {
  return process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3000';

  const basePath = 'dealers';
  // if (ENV === 'production') {
  //   return `https://api.latitudeshowtracker.com/${basePath}`;
  // }

  // if (ENV === 'staging') {
  //   return `https://staging.api.latitudeshowtracker.com/${basePath}`;
  // }

  // // Development
  // return `http://localhost:3000/${basePath}`;
}

export const API_URL = getApiUrl();

export const APP_VERSION = process.env.NEXT_PUBLIC_APP_VERSION || '1.0.0';
